import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_ADMIN || 'http://localhost:4000/api/admin',
  withCredentials: true,
});

// Get all hero sections
export const getAllHeroSections = async () => {
  const response = await api.get('/hero-sections');
  return response.data;
};

// Get hero sections by type
export const getHeroSectionsByType = async (type) => {
  const response = await api.get(`/hero-sections/type/${type}`);
  return response.data;
};

// Get a single hero section by ID
export const getHeroSectionById = async (id) => {
  const response = await api.get(`/hero-sections/${id}`);
  return response.data;
};

// Create a new hero section
export const createHeroSection = async (heroSectionData) => {
  // Don't set Content-Type for FormData - browser will handle it
  let config = {};
  
  if (!(heroSectionData instanceof FormData)) {
    config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
  }
  
  // Debug what's in the FormData
  if (heroSectionData instanceof FormData) {
    console.log('FormData contents:');
    for (let pair of heroSectionData.entries()) {
      if (pair[1] instanceof File) {
        console.log(`${pair[0]}: File (${pair[1].name}, ${pair[1].size} bytes)`);
      } else {
        console.log(`${pair[0]}: ${pair[1]}`);
      }
    }
  }
  
  const response = await api.post('/hero-sections', heroSectionData, config);
  return response.data;
};

// Update a hero section
export const updateHeroSection = async ({ id, formData }) => {
  // Check if data is FormData (containing images) or regular object
  const config = {
    headers: {
      'Content-Type': formData instanceof FormData ? 'multipart/form-data' : 'application/json',
    },
  };
  
  const response = await api.patch(`/hero-sections/${id}`, formData, config);
  return response.data;
};

// Delete a hero section
export const deleteHeroSection = async (id) => {
  const response = await api.delete(`/hero-sections/${id}`);
  return response.data;
};